import { Element, Icon, RouterLink } from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { memo } from 'react';
import { ITransfer } from '@zmedia/bm-soccer-ui/interface';
import { Team } from '@zmedia/bm-soccer-ui/modules/match';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { unixToDate } from '@zmedia/bm-soccer-ui/utils/date';
import styles from './style.module.scss';

interface IProps {
    item: ITransfer;
}
export function TransferItem(props: IProps) {
    const { item } = props;

    const { fTeam, tTeam, note, player, date } = item;
    return (
        <Element className={styles['transfer-item']}>
            <Element renderAs="time">
                {unixToDate(date, 'DD [thg] MM, YYYY')}
            </Element>
            <RouterLink
                className={styles['transfer-player']}
                to={`${URL_SOCCER_PAGE.SUBPATH}${player.path}`}
                tabIndex={-1}
                title={player.name}
            >
                <Avatar avatar={player.avatar} name={player.name}>
                    <Element className={styles['position']}>
                        {player.position?.shortName}
                    </Element>
                </Avatar>
                <Element className={styles['name']}>{player.name}</Element>
            </RouterLink>
            <Element
                className={cn(styles['transfer-team'], {
                    [styles['not-full-transfer']]: !fTeam || !tTeam,
                })}
            >
                {fTeam ? <Team team={fTeam} /> : <></>}
                {tTeam && fTeam && <Icon icon="forward" />}
                {tTeam ? <Team team={tTeam} /> : <></>}
            </Element>
            <Element className={styles['text']} renderAs="span">
                {note}
            </Element>
        </Element>
    );
}

export default memo(TransferItem);
